import { CommissionBonusScheduleResponse } from "../../../domain/models/integration/commission-bonus-schedule.model";

type UnknownRecord = Record<string, unknown>;
const isRecord = (value: unknown): value is UnknownRecord => typeof value === "object" && value !== null && !Array.isArray(value);
const isNullableNumber = (value: unknown): value is number | null => value === null || (typeof value === "number" && Number.isFinite(value));
const isNullableString = (value: unknown): value is string | null => value === null || typeof value === "string";

export function isCommissionBonusScheduleResponse(value: unknown): value is CommissionBonusScheduleResponse {
  return isRecord(value) &&
    isNullableNumber(value["paidStatus"]) &&
    isNullableNumber(value["totalMembers"]) &&
    isNullableNumber(value["commissionPayment"]) &&
    isNullableNumber(value["totalSales"]) &&
    isNullableString(value["payDate"]) &&
    isNullableNumber(value["saleAmount"]) &&
    isNullableNumber(value["amountToPay"]) &&
    isNullableNumber(value["totalPaid"]) &&
    isNullableNumber(value["difference"]);
}
